import { Empty } from 'antd';
import React from 'react';

const EmptyComponents = () => <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />;
export default EmptyComponents;
